<template>
  <div class="titulo-pagina">
    <h1 v-if="getTitle">{{ getTitle | nameBreadcrumb }}</h1>
    <div class="caminhos" v-if="getBreadcrumb.length > 0">
      <ul>
        <li
          v-for="(item, index) in getBreadcrumb"
          :key="index"
          class="breadcrumb"
        >
          <router-link v-if="item.href" :to="item.href">{{
            item.name
          }}</router-link>
          <a v-else href="javascript:void(0)" :key="index">{{ item.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import mixins from '@/helpers/mixins';

export default {
  name: 'TituloPagina',
  mixins: [mixins],
  computed: {
    ...mapState('route', {
      routeName: state => state.name,
      routeParams: state => state.params,
    }),
    ...mapGetters({
      getBreadcrumb: 'breadcrumb/getBreadcrumb',
      getTitle: 'breadcrumb/getTitle',
    }),
  },
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.setBreadcrumb({
        name: this.routeName,
        params: this.routeParams,
      });
    });
  },
  watch: {
    '$store.state.route': {
      handler(after) {
        this.setBreadcrumb({
          name: after.name,
          params: after.params,
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.titulo-pagina {
  @extend %area-de-utilizacao;
  @extend %flex;
  @extend %direction-row;
  @extend %align-items-end;
  @extend %justify-between;
  @extend %nao-selecionavel;
  margin: 0 auto;
  margin-bottom: 11px;

  & h1 {
    font-size: 11px;
    margin: 0px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-family: 'VivoType';
    color: $cor_roxo;
  }

  & p,
  span {
    font-family: 'VivoType';
    font-size: 15px;
    line-height: 15px;
    margin: 0px;
    color: $cor_primaria_40;
    @extend %nao-selecionavel;
  }

  & .caminhos {
    @extend %flex;
    @extend %direction-row;
    @extend %align-items-center;

    & ul {
      display: flex;
      flex-direction: row;
      list-style: none;
      margin: 0;
      padding: 0;

      & li.breadcrumb {
        display: flex;
        flex-direction: row;
        padding-right: 10px;
        &:after {
          font-size: 15px;
          padding: 0px 5px;
          font-style: italic;
          white-space: pre;
          margin-left: 10px;
          content: '/';
        }
        &:last-child:after {
          margin-left: 0;
          content: none;
        }

        &:last-child {
          margin-right: 0;
        }

        & a {
          padding: 0 1px;
          font-size: 15px;
          line-height: 20px;
          font-weight: bold;
          text-decoration: none;
          font-family: 'VivoType';
          color: $cor_roxo;
          max-width: 250px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;

          &:hover {
            color: $cor_rosa;
          }
        }
      }
    }
  }
}

@media all and (min-width: 300px) and (max-width: 679px) {
  .titulo-pagina {
    padding: 0 20px;
    margin-bottom: 3px;

    .caminhos {
      & a {
        font-size: 10px;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .titulo-pagina {
    padding: 0 40px;
    margin-bottom: 5px;

    .caminhos {
      & a {
        font-size: 13px;
      }
    }
  }
}
</style>
